import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

const Terms = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // If there's a previous page in the history, go back
    // Otherwise, default to landing page
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg text-gray-300 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <button
            onClick={handleBack}
            className="text-blue-500 hover:text-blue-400 transition-colors inline-flex items-center gap-2"
          >
            <ArrowLeftIcon className="w-4 h-4" />
            Back
          </button>
        </div>

        <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>

        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using Notui, you agree to be bound by these Terms
              of Service and our Privacy Policy. If you disagree with any part
              of these terms, you may not access our service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              2. Service Description
            </h2>
            <p>Notui provides:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>AI-powered note-taking and organization tools</li>
              <li>Document analysis and summarization</li>
              <li>Interactive AI chat assistance</li>
              <li>Automated test generation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              3. User Responsibilities
            </h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Provide accurate account information</li>
              <li>Maintain account security</li>
              <li>Use the service legally and ethically</li>
              <li>Not share account credentials</li>
              <li>Not misuse AI features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              4. Intellectual Property
            </h2>
            <p>
              Users retain ownership of their content. You grant Notui a license
              to:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Store and process your content</li>
              <li>Generate AI-powered analysis</li>
              <li>Create derivative works for your use</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              5. Service Limitations
            </h2>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>AI features may have accuracy limitations</li>
              <li>Service availability is not guaranteed</li>
              <li>Features may change without notice</li>
              <li>Usage limits may apply</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              6. Termination
            </h2>
            <p>
              We may terminate or suspend access to our service immediately,
              without prior notice, for:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Terms of Service violations</li>
              <li>Abusive or harmful behavior</li>
              <li>Extended inactivity</li>
              <li>As required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              7. Changes to Terms
            </h2>
            <p>
              We reserve the right to modify these terms at any time. We will
              notify users of significant changes via email or service
              notification.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">
              8. Contact
            </h2>
            <p>For questions about these terms, contact us at:</p>
            <p className="mt-2">abdulwahiddm1@gmail.com</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
